import { mergeReplace } from "utils/payload.utils";

export const ACTION_SET_ALERTS = "alerts__set";
export const ACTION_REPLACE_ALERTS = "alerts__replace";
export const ACTION_REPLACE_ALERTS_ORGANIZATION = "alerts_organization_replace";

export const alertInitialState = {
  alertList: [],
};

export default function alertReducer(state, action) {
  switch (action.type) {
    case ACTION_SET_ALERTS:
      return {
        ...state,
        alertList: action.payload,
      };
    case ACTION_REPLACE_ALERTS:
      return {
        ...state,
        alertList: mergeReplace(
          state.alertList,
          action.payload,
          "UserAlert_ID",
        ),
      };
    case ACTION_REPLACE_ALERTS_ORGANIZATION:
      return {
        ...state,
        alertList: state.alertList.filter(
          (alert) =>
            alert._associations.Alert.Organization_ID !== action.payload,
        ),
      };
    default:
      return state;
  }
}
